<script lang="ts">
  /**
   * De combien avancent les boutons + et − de la page.
   *
   * Un seul réglage pour toute l'étape plutôt que six boutons par ligne : les
   * lignes restent lisibles sur un téléphone, et le pas se choisit une fois
   * pour toutes au moment où l'on sait ce qu'on veut répartir.
   */
  let { pas, onchange }: { pas: number; onchange: (v: number) => void } = $props()

  const choix = [1, 5, 10]
</script>

<div class="reglage" role="group" aria-label="Pas des boutons">
  <span class="etiquette">Pas</span>
  {#each choix as p (p)}
    <button
      type="button"
      class:actif={p === pas}
      aria-pressed={p === pas}
      onclick={() => onchange(p)}
    >
      {p}
    </button>
  {/each}
</div>

<style>
  .reglage {
    display: inline-flex;
    align-items: center;
    gap: var(--pas);
  }
  .etiquette {
    font-family: 'Cinzel', serif;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-size: 0.7rem;
    color: var(--ink-soft);
    margin-right: var(--pas);
  }
  button {
    min-width: 2rem;
    height: 1.8rem;
    border: 1px solid var(--line);
    background: var(--surface);
    color: var(--ink-soft);
    border-radius: var(--r);
    font: inherit;
    font-size: 0.8rem;
    font-variant-numeric: tabular-nums;
    cursor: pointer;
  }
  button:hover {
    border-color: var(--line-fort);
    color: var(--ink);
  }
  button.actif {
    border-color: var(--gold);
    color: var(--gold);
  }
</style>
